import { createFileRoute } from '@tanstack/react-router';
import { PayRent } from '../pages/PayRent';
import { ProtectedRoute } from '../../../shared/ui';

export const Route = createFileRoute('/pay-rent')({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <ProtectedRoute>
      <PayRent />
    </ProtectedRoute>
  );
}
